import fonts from '../fonts';

const typography = {
  h1: {
    ...fonts.header,
    fontWeight: 700,
    fontSize: 38,
    lineHeight: 1.2
  },
  h2: {
    ...fonts.header,
    fontWeight: 700,
    fontSize: 32,
    lineHeight: 1.2
  },
  h3: {
    ...fonts.header,
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 1.2
  },
  h4: {
    ...fonts.header,
    fontWeight: 400,
    fontSize: 20,
    lineHeight: 1.2
  },
  h5: {
    ...fonts.text,
    fontWeight: 400,
    fontSize: 17,
    lineHeight: 1.2
  },
  h6: {
    ...fonts.text,
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 1.2
  },
  subtitle1: {
    ...fonts.text,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5
  },
  subtitle2: {
    ...fonts.text,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5
  },
  body1: {
    ...fonts.text,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5
  },
  body2: {
    ...fonts.text,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5
  }
};

export default typography;
